import { retrieveFromWindow } from '../utils'

const minSpend = retrieveFromWindow('minSpend', { value: 15000 })

export interface ICartConfig {
  minimumDollarAmount: number
}

export const cart: ICartConfig = {
  // @IMPROVEMENT: Would prefer to see the cart dealing with cents, not dollars. Floats are untrustworthy.
  minimumDollarAmount: minSpend.value / 100
}
